"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPaidOffPlatformPointsEndpoint = void 0;
const endpointIds_1 = require("root/src/shared/descriptions/endpoints/endpointIds");
const auth_1 = require("root/src/shared/constants/auth");
const payloadSchema = {
    type: 'object',
    properties: {
        userId: {
            type: 'string',
        },
        campaignId: {
            type: 'string',
        },
        modificationValue: {
            type: 'number',
        },
    },
    required: ['userId', 'campaignId', 'modificationValue'],
    additionalProperties: false,
};
const responseSchema = {
    type: 'object',
    properties: {
        userId: {
            type: 'string',
        },
        campaignId: {
            type: 'string',
        },
        modificationValue: {
            type: 'number',
        },
    },
    required: ['userId', 'campaignId', 'modificationValue'],
    additionalProperties: false,
};
exports.addPaidOffPlatformPointsEndpoint = {
    [endpointIds_1.ADD_PAID_OFF_PLATFORM_POINTS]: {
        authentication: auth_1.authenticationTypes.authenticated,
        payloadSchema,
        responseSchema,
        authenticationRole: auth_1.userGroups.admin,
    },
};
